// ============================================================================
// PROCEEDING TYPE ENDPOINTS
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const PROCEEDING_TYPE_BASE_PATH = '/ProceedingType';

export const proceedingTypeEndpoints = {
  list: () => buildEndpoint(PROCEEDING_TYPE_BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${PROCEEDING_TYPE_BASE_PATH}/:id`, { id }),
  getByCode: (code: string) => buildEndpointWithParams(`${PROCEEDING_TYPE_BASE_PATH}/code/:code`, { code }),
  create: () => buildEndpoint(PROCEEDING_TYPE_BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${PROCEEDING_TYPE_BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${PROCEEDING_TYPE_BASE_PATH}/:id`, { id }),
  validateCode: (code: string) => buildEndpointWithParams(`${PROCEEDING_TYPE_BASE_PATH}/validate/code/:code`, { code }),
} as const;

export default proceedingTypeEndpoints;
